export const onClickOutside = (
  el: HTMLElement,
  callback: (e: Event) => void,
) => {
  document.addEventListener("click", (e) => {
    if (!el.contains(e.target as Node)) {
      callback(e);
    }
  });
};
